export const environment = {
  production: true,
  apiUrl: "", //http://10.0.12.10:8080/REAL_GIS_DESJava/rest
  project: "Zipaquirá",
  login: false,
  version: "3.3", //Migrated to angular v15
  portalUrl: "https://gisrealidad5.com/portal/",
  mapId: "b59ec7c5772240b4abcaae57d072a301",
  mapIdPot: "ab41fdd5f9184f3fa251c49b456c287f", 
  mapIdfact: "a82bb4fb3c6f455e8893cbba05f4dc5b",
  apiKeyArcGIS: null,
  imagesDate: "Diciembre 2023", // use this format: 01 enero 1990
  dashboardUrl:"https://gisrealidad5.com/portal/apps/dashboards/a82bb4fb3c6f455e8893cbba05f4dc5b",
  documentationUrl:"https://drive.google.com/file/d/1a1nHHbRTxpW2emJ2EqGXbiKfciuRICR7/view?usp=sharing",
  modules: {
    view360: true,
    baseMapGallery: true,
    layerList: true,
    search: true,
    searchCatastral: true,
    select: true,
    measurement: true,
    tableAttribute: false, // widget en planeación
    addLayer: true,
    overviewMap: true,
    print: true,
    dashboard: true,
    editor: false,
    mapPot: false,
    allowdownload: true
  }
};
